import React from 'react';
import { Users } from 'lucide-react';
import AvatarSelector from '../../ui/AvatarSelector';
import type { UnifiedOnboardingData } from '../../../lib/onboarding/unifiedTypes';

interface CoachPersonalityStepProps {
  data: UnifiedOnboardingData;
  onUpdate: (updates: Partial<UnifiedOnboardingData>) => void;
  onNext: () => void;
}

export default function CoachPersonalityStep({ data, onUpdate, onNext }: CoachPersonalityStepProps) {
  const handlePersonalitySelect = (personality: any) => {
    onUpdate({ selectedPersonality: personality });
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <Users className="h-12 w-12 text-pink-400 hidden md:block mx-auto mb-4" />
        <h3 className="md:text-lg font-semibold text-gray-900 mb-2">
          Choose Your Coach Personality
        </h3>
        <p className="md:text-base text-sm text-gray-600">
          Click on an avatar to hear a preview and select your coaching style
        </p>
      </div>

      <AvatarSelector
        selectedPersonality={data.selectedPersonality}
        onSelect={handlePersonalitySelect}
      />

      {data.selectedPersonality && (
        <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4">
          <p className="text-emerald-800 text-sm text-center">
            Great choice! Your coach will adapt to this personality style.
          </p>
        </div>
      )}
    </div>
  );
}